export default __webpack_public_path__ + "static/media/MotherDay_14.bcf5e628.png";